import {Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {
  Command,
  CommandStore,
  SOFTLINE_FEATURE_COMMANDS,
  SOFTLINE_FEATURE_TITLE,
  TitleStore
} from '@softline/application';
import {Store} from '@softline/core';
import {Router, RouterModule} from '@angular/router';

@Component({
    selector: 'lib-coupon-app',
    imports: [RouterModule],
    templateUrl: './coupon-app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./coupon-app.component.css']
})
export class CouponAppComponent implements OnInit, OnDestroy {

  constructor(
    private store: Store,
    protected router: Router
  ) { }

  async ngOnInit(): Promise<void> {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#COUPONS.TITLE');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.addSet, {
      name: CouponAppComponent,
      commands: this.createCommands()
    });
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
    this.store.commit(SOFTLINE_FEATURE_COMMANDS, CommandStore.mutations.removeSet, CouponAppComponent);
  }

  protected createCommands(): Command[] {
    return [
      {
        icon: 'fa-regular fa-barcode-scan',
        name: 'Gutscheinkarten',
        class: 'menu main-menu main-menu-top info',
        execute: () => this.router.navigate(['/gutscheinkarten'])
      }, {
        icon: 'fa-regular fa-chart-line',
        name: 'Tagesbilanz',
        class: 'menu main-menu main-menu-top info',
        execute: () => this.router.navigate(['/gutscheinkarten/daily-balance'])
      }
    ];
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }
}
